module.exports = __webpack_public_path__ + "static/media/objects2_09.ca9dff04.svg";